module.exports = __webpack_public_path__ + "img/next_q_btn.99c596de.png";